// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1M2K0","ranges":"BmiRanges_ranges__3Z8Mj"};